import React from 'react';
import PropTypes from 'prop-types';

import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';
import Button from '../../../01_atoms/Button';
import NextChevronIcon from '../../../../public/static/icons/navigation-chevron-right-white-thick.svg';

import styles from './index.module.scss';

const MoneyHandle = ({
  label,
  description,
  buttonLabel,
  onSubmit = () => {},
  amount = null,
  position,
}) => (
  <div
    tabIndex="0"
    role="button"
    className={`${styles['money-handle']}`}
    data-title={label}
    data-category="Money handles inline checkout block"
    data-component="money-handle"
    data-test={`Money handles inline checkout block ${label}`}
    onClick={() => onSubmit(amount, position)}
    onKeyDown={(e) => (e.keyCode === 13 ? onSubmit(amount, position) : undefined)}
  >
    <h3 className={`${styles['money-handle__label']}`}>{label}</h3>
    <div className={`${styles['money-handle__description']}`}>{description}</div>
    <Button
      type="white-pink"
      isOutlined
      isBlock
      className={`${styles['money-handle__button']}`}
      tabIndex="-1"
    >
      {buttonLabel}
    </Button>
    <NextChevronIcon aria-hidden="true" className={`${styles['money-handle__icon']}`} />
  </div>
);

const moneyHandlePropTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  amount: PropTypes.number,
};

MoneyHandle.propTypes = {
  ...moneyHandlePropTypes,
  position: PropTypes.number.isRequired,
};

const BBMoneyHandlesInlineCheckout = ({
  variant,
  heading = '',
  subheading = '',
  moneyHandles,
  onSubmit,
  behaviorSettings = null,
  uuid = null,
}) => {
  const classes = [
    'bb',
    styles['bb-money-handles-inline-checkout'],
    styles[`bb-money-handles-inline-checkout--variant-${variant}`],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div id={uuid} className={classes.join(' ')}>
      <div className="container">
        {heading && (
          <h2 className={`${styles['bb-money-handles-inline-checkout__title']}`}>{heading}</h2>
        )}
        {subheading && (
          <div className={`${styles['bb-money-handles-inline-checkout__subtitle']}`}>
            {subheading}
          </div>
        )}
        <div className={`${styles['bb-money-handles-inline-checkout__items']}`}>
          {moneyHandles.map((item, index) => (
            <MoneyHandle key={index} {...item} position={index + 1} onSubmit={onSubmit} />
          ))}
        </div>
      </div>
    </div>
  );
};

BBMoneyHandlesInlineCheckout.propTypes = {
  variant: PropTypes.oneOf(['dark', 'light']).isRequired,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  moneyHandles: PropTypes.arrayOf(PropTypes.shape(moneyHandlePropTypes)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBMoneyHandlesInlineCheckout;
